export function findForm(el: HTMLElement | null) {
  let form = el;
  while (form && form.tagName !== 'FORM') {
    form = form.parentElement;
  }
  return form;
}
